import { render, staticRenderFns } from "./LeaveRequest.vue?vue&type=template&id=a0402284&"
import script from "./LeaveRequest.vue?vue&type=script&lang=js&"
export * from "./LeaveRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports